import { QueryFactory } from "../../../../Common";
export const QPlaceBets = QueryFactory("PlaceBets");
//# sourceMappingURL=QPlaceBets.js.map